export interface RecruiterSignatureResponse {
    id: string;
    signature: string;
}

export const DefaultRecruiterSignatureResponse: RecruiterSignatureResponse = {
    id: '',
    signature: '',
};
